import React from "react";
import {
    Row,
    Col,
    Input,
    Space,
    Button,
    Select,
    Form,
    useModalForm,
    Modal,
} from "@pankod/refine-antd";
import { useList } from "@pankod/refine-core";

export const AcceptTransBnkRequestModal: React.FC<{ refetchTableProps?: any, recordDetails: any }> = ({ refetchTableProps, recordDetails }) => {
    const {
        id: bankUserAuthorizationRequestId,
        bankIntegrationId: integrationId,
        credentials: {
            entityTypeId,
            businessTypeId,
            nameOnBank: brandName,
        },
        bankAccountValidationRequest: {
            accountNumber,
        }
    } = recordDetails;

    const { data: bankCodesData, isLoading: bankCodesLoading } = useList<any>({
        dataProviderName: "grapghQl",
        resource: 'getBankCodesByIntegrationId',
        metaData: { integrationId },
        queryOptions: { enabled: !!integrationId },
    });
    const bankCodes: string[] = bankCodesData?.data || [];

    const {
        modalProps: acceptTransBnkRequestModal,
        formProps: acceptTransBnkRequestForm,
        show: acceptTransBnkRequestShow,
        close: acceptTransBnkRequestClose
    } = useModalForm({
        action: "create",
        dataProviderName: "grapghQl",
        resource: "updateAndGrantCorporateOnboardingRequestForConnectedBanking",
        metaData: {
            bankUserAuthorizationRequestId,
            entityTypeId,
            businessTypeId,
            brandName
        },
        redirect: false,
        onMutationSuccess() {
            acceptTransBnkRequestClose()
            refetchTableProps(true)
        }
    });

    acceptTransBnkRequestModal.title = 'Accept TransBnk Request';
    acceptTransBnkRequestModal.confirmLoading = true;
    acceptTransBnkRequestModal.centered = true;
    acceptTransBnkRequestModal.width = 800;
    acceptTransBnkRequestModal.onCancel = () => {
        acceptTransBnkRequestForm.form?.resetFields();
        acceptTransBnkRequestClose();
    }

    return (
        <Space>
            <Button type={"primary"} onClick={() => { acceptTransBnkRequestShow() }}  >
                Accept
            </Button>
            <Modal {...acceptTransBnkRequestModal}>
                <Form
                    {...acceptTransBnkRequestForm}
                    layout="vertical"
                    initialValues={{
                        entityTypeId,
                        businessTypeId,
                        debitAccNo: accountNumber,
                    }}
                >
                    <Row gutter={16}>
                        <Col span={8}>
                            <Form.Item
                                label="Bank Code"
                                name="bankCode"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please select a value.",
                                    },
                                ]}
                            >
                                <Select
                                    loading={bankCodesLoading}
                                    options={bankCodes.map((code: string) => ({
                                        value: code,
                                        label: code,
                                    }))}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                name="corpId"
                                label="Corporate Id"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please enter the Corporate Id.",
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                name="userId"
                                label="User Id"
                                rules={[
                                    { required: true, message: "Please enter the User Id." }
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                name="debitAccNo"
                                label="Debit Account Number"
                                rules={[
                                    { required: true, message: "Please enter the Debit Account Number." }
                                ]}
                            >
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                name="natureOfBusiness"
                                label="Nature Of Buisness"
                                rules={[
                                    { required: true, message: "Please enter the field." }
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="categoryType"
                                label="Category"
                                rules={[
                                    { required: true, message: "Please enter the field." }
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={8}>
                            <Form.Item
                                name="entityId"
                                label="Entity Id"
                                rules={[
                                    { required: true, message: "Please enter the Entity Id." }
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                name="programId"
                                label="Program Id"
                                rules={[
                                    { required: true, message: "Please enter the Program Id." }
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                name="tokenNumber"
                                label="Token Number"
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </Space>
    );
};